/**
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0.
 */

import { mqtt, iot, auth } from "aws-iot-device-sdk-v2";
import * as AWS from "aws-sdk";
//import { CognitoUser, CognitoUserPool, AuthenticationDetails,CognitoUserSession } from 'amazon-cognito-identity-js';
import { CognitoUser, CognitoUserPool, AuthenticationDetails, CognitoUserSession } from 'amazon-cognito-identity-js';


const Settings = require("./settings");
const $ = require("jquery");

let provider: AWSSTSCredentialsProvider;
let connection: mqtt.MqttClientConnection;
let credentials = {
  "AccessKeyId": "",
  "SecretAccessKey": "",
  "SessionToken": "",
  "IoT_Endpoint": "",
  "topic": "",
  "region": ""
};

/* Cognito 2nd Try*/

const clientId: string = '1g4oall9ssvc6mm7i9tk4tn4rk';
const redirectUri: string  = 'https://letsgoscope.com';
const tokenUrl: string  = 'https://x-biomedical.auth.us-east-2.amazoncognito.com/oauth2/token';
const hostedUiUrl: string  = "https://x-biomedical.auth.us-east-2.amazoncognito.com/oauth2/authorize?client_id=1g4oall9ssvc6mm7i9tk4tn4rk&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Fletsgoscope.com";
//const streamsEndpoing: string = "https://lz8ov1y256.execute-api.us-east-2.amazonaws.com/Telestration_testing/telestrationGetStreams"
const streamsEndpoing: string = "https://lz8ov1y256.execute-api.us-east-2.amazonaws.com/Telestration_testing"


interface Tokens {
  id_token: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

async function exchangeAuthorizationCode(code: string): Promise<Tokens | undefined> {
  const params = new URLSearchParams();
  params.append('grant_type', 'authorization_code');
  params.append('client_id', clientId);
  params.append('redirect_uri', redirectUri);
  params.append('code', code);

  try {
    const response = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });

    if (!response.ok) {
      throw new Error('Error intercambiando el código por tokens');
    }

    const tokens: Tokens = await response.json();
    return tokens;
  } catch (error) {
    console.error('Error:', error);
    return undefined;  
  }
}

function handleCallback(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const code: string | null = urlParams.get('code');

  if (code) {
    exchangeAuthorizationCode(code).then(tokens => {
      if (tokens && tokens.id_token) {
        localStorage.setItem('sessionToken', tokens.id_token);
        window.location.href = '/';
      }
    });
  }
  else
  {
    checkSession()
  }
  
}

function checkSession()
{
  //if ther is not session, lets go back to get the session
  if (!localStorage.getItem('sessionToken')) {
      window.location.href = hostedUiUrl;
  } else {
    console.log('We have already logged in');
  }
}


handleCallback();






/* Cognito 2nd Try*/



// Start Cognito related
let username = "";
let password = "";

const poolData = {
  UserPoolId : 'us-east-2_rNLHwdhU5',
  ClientId : '1g4oall9ssvc6mm7i9tk4tn4rk'
};
const userPool = new CognitoUserPool(poolData);


function checkLoginCognito(){
  const getCurrentUser = () => {
    return userPool.getCurrentUser();
  };
  const checkSession = () => {
    const cognitoUser = getCurrentUser();
  
    if (cognitoUser != null) {
      cognitoUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
        if (err) {
          console.error(err);
          // Manejar el error
          return;
        }
      
        if (session && session.isValid()) {
          console.log('Sesión válida', session);
          // La sesión es válida
        } else {
          console.log('Sesión no válida');
          // Manejar sesión no válida
        }
      });
    } else {
      console.log('No hay un usuario actual');
      // No hay sesión iniciada, redirigir o mostrar inicio de sesión
    }
  };
  
  // Llamar a checkSession en el punto adecuado de tu aplicación
  checkSession();
  
}


function loginCognito() {

  username = (document.getElementById('username') as HTMLInputElement).value;
  password = (document.getElementById('password') as HTMLInputElement).value;

  var authenticationData = {
    Username: username,
    Password: password,
  };
  var authenticationDetails = new AuthenticationDetails(authenticationData);
  
  var userData = {
    Username: username,
    Pool: userPool
  };
  
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess: function(result) {
        console.log('Acceso concedido');
        console.log(result);
        // Aquí puedes redirigir al usuario o realizar otras acciones
        
        // Asumiendo que 'result' contiene el resultado exitoso de cognitoUser.authenticateUser
        const credentials = AWS.config.credentials;
        console.log("Login Done"+credentials)
    },
  
    onFailure: function(err) {
        console.error('Acceso denegado');
        console.error(err);
    }
  });

}



// Finish Cognito related


export class AWSSTSCredentialsProvider extends auth.CredentialsProvider{
  private aws_credentials : auth.AWSCredentials;
  constructor(expire_interval_in_ms? : number)
  {
    super();

    AWS.config.region = credentials.region;
    this.aws_credentials =
    {
        aws_region: credentials.region,
        aws_access_id : credentials.AccessKeyId,
        aws_secret_key: credentials.SecretAccessKey,
        aws_sts_token: credentials.SessionToken
    }

    setInterval(async ()=>{
        await this.refreshCredentialAsync();
    },expire_interval_in_ms?? 3600*1000);
  }

  getCredentials(){
      return this.aws_credentials;
  }

  async refreshCredentialAsync()
  {
    return new Promise<AWSSTSCredentialsProvider>((resolve, reject) => {
        console.log("we have to refresh STS tokens")
        fetchTokens(username, password);
        this.aws_credentials.aws_access_id = credentials.AccessKeyId;
        this.aws_credentials.aws_secret_key = credentials.SecretAccessKey;
        this.aws_credentials.aws_sts_token = credentials.SessionToken;
        resolve(this)
    });
  }
}


//Get Tokens function
async function fetchTokens(username: string, password: string): Promise<any> {
  const response = await fetch(streamsEndpoing, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
          token: localStorage.getItem('sessionToken')
      }),
  });

  if (!response.ok) {
      throw new Error('Failed to fetch tokens');
  }

  const data = await response.json();
  if (data == -1)
  {
    console.log("we must recharge page and ask for another code")
    localStorage.removeItem('sessionToken');
    window.location.reload();
  }
  credentials.AccessKeyId=data.AccessKeyId
  credentials.SecretAccessKey=data.SecretAccessKey
  credentials.SessionToken=data.SessionToken
  credentials.IoT_Endpoint=data.IoT_Endpoint
  credentials.topic=data.topic
  credentials.region=data.region
  console.log(credentials)
  return data;
}




function sendMessage() {
  // Get the message from the input field
  const message = $("#message").val();
  console.log("el mensaje es : "+message)
  if (connection && message) {
      // Publish the message to the topic
      connection.publish(credentials.topic, message.toString(), mqtt.QoS.AtLeastOnce);
      log(`Message sent: ${message}`);
  } else {
      log("Connection is not established or message is empty.");
  }
}

function sendDrawCoordinates_iot(data: object): void {
  var iotFormat = {
    "draw" :data
    }
  console.log("El mensaje es:", iotFormat);


  if (connection && data) {
    const message = JSON.stringify(iotFormat);
    // Publish the message to the topic
    connection.publish(credentials.topic, message, mqtt.QoS.AtLeastOnce);
    log(`Message sent: ${message}`);
  } else {
    log("Connection is not established or message is empty.");
  }
}

// Exporta la función al ámbito global
(window as any).sendDrawCoordinates_iot = sendDrawCoordinates_iot;


$(document).ready(() => {
  $("#sendMessage").on("click", sendMessage);
});

function log(msg: string) {
  $("#console").append(`<pre>${msg}</pre>`);
}


async function connect_websocket(provider: auth.CredentialsProvider) {
  return new Promise<mqtt.MqttClientConnection>((resolve, reject) => {
    let config = iot.AwsIotMqttConnectionConfigBuilder.new_builder_for_websocket()
        .with_clean_session(true)
        .with_client_id("test-" + Math.floor(Math.random() * 100000000))
        .with_endpoint(Settings.AWS_IOT_ENDPOINT)
        .with_credential_provider(provider)
        .with_use_websockets()
        .with_keep_alive_seconds(30)
        .build();

    log("Connecting websocket...");
    const client = new mqtt.MqttClient();

    connection = client.new_connection(config);
    connection.on("connect", (session_present) => {
      resolve(connection);
    });
    connection.on("interrupt", (error) => {
      log(`Connection interrupted: error=${error}`);
    });
    connection.on("resume", (return_code, session_present) => {
      log(`Resumed: rc: ${return_code} existing session: ${session_present}`);
    });
    connection.on("disconnect", () => {
      log("Disconnected");
    });
    connection.on("error", (error) => {
      reject(error);
    });
    connection.connect();
  });
}

async function main() {

  if (!localStorage.getItem('sessionToken')) 
  {
    return;
  }
    
  
  try {
    await fetchTokens(username, password);
  } 
  catch (error) {
      console.error('Error fetching tokens:', error);
  }

  provider = new AWSSTSCredentialsProvider(55*60*1000);//(55 minutes * 60 seconds * 1000 miliSeconds)
  //console.log(provider);
  /** Make sure the credential provider fetched before setup the connection */
  await provider.refreshCredentialAsync();
  connect_websocket(provider)
  .then((connection) => {
      connection
        .subscribe(
          credentials.topic,
          mqtt.QoS.AtLeastOnce,
          (topic, payload, dup, qos, retain) => {
            const decoder = new TextDecoder("utf8");
            let message = decoder.decode(new Uint8Array(payload));
            log(`Message received: topic=${topic} message=${message}`);
            /** The sample is used to demo long-running web service.
             * Uncomment the following line to see how disconnect behaves.*/
            // connection.disconnect();
          }
        )
        /*.then((subscription) => {
          log(`start publish`)
          var msg_count = 0;
          connection.publish(subscription.topic, `Hello world! ${msg_count}`, subscription.qos);
    
          setInterval( ()=>{
            msg_count++;
            const msg = `I am sending a message! ${msg_count}`;
            connection.publish(subscription.topic, msg, subscription.qos);
          }, 60000);
        });*/
    })
    .catch((reason) => {
      log(`Error while connecting: ${reason}`);
    });
}

document.addEventListener('DOMContentLoaded', (event) => {
  const loginButton = document.getElementById('loginButton');
  if (loginButton) {
      loginButton.addEventListener('click', main);
  }
});

document.addEventListener('DOMContentLoaded', (event) => {
  const loginCogButton = document.getElementById('loginCognitoBtn');
  if (loginCogButton) {
    loginCogButton.addEventListener('click', loginCognito);
  }
});

document.addEventListener('DOMContentLoaded', (event) => {
  const checkCogButton = document.getElementById('checkCogButton');
  if (checkCogButton) {
    checkCogButton.addEventListener('click', checkLoginCognito);
  }
});


main();